import React, { useState, useEffect, useRef } from "react";
import { CiCircleChevLeft, CiCircleChevRight } from "react-icons/ci";
import { FaQuoteLeft } from "react-icons/fa";
import { motion } from "framer-motion";

const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowWidth;
};

const Clients = () => {
  const testimonials = [
    {
      name: "Muhammad Rehan",
      color: "red",
      rating: 5,
      image: require("../assets/images/clients/p1.png"),
      feedback:
        "AS-Tech Community is an incredibly supportive and versatile WhatsApp group dedicated to helping members across various situations and fields. Whether you need technical assistance, professional advice, or just a bit of encouragement, AS-Tech Community is the place to turn to. The members are knowledgeable, friendly, and always willing to lend a hand. The group's collaborative atmosphere ensures that you never feel alone in solving problems or navigating challenges. Highly recommended for anyone looking for a reliable and responsive community!",
    },
    {
      name: "Zia Ullah Khan",
      color: "blue",
      rating: 5,
      image: require("../assets/images/clients/p2.png"),
      feedback:
        "AS-Tech Community has greatly enhanced my writing skills and freelance career. Anum Shaheen’s dedication and talent inspire excellence, and the supportive environment fosters growth. This community is perfect for beginners, offering valuable opportunities in freelancing and e-business. Highly recommended for anyone looking to start or advance their freelance journey. Thank you, Anum!",
    },
    {
      name: "Aftab Pitafi",
      color: "orange",
      rating: 5,
      image: require("../assets/images/clients/p3.png"),
      feedback:
        "AS - Tech Community is a wonderful platform for learning and earning. It provides skillful people for solution of your problems. It provides amazing educational and learning platform for work providers and learners. Highly recommended",
    },
    {
      name: "Qaisar Ali",
      color: "indigo",
      rating: 5,
      image: require("../assets/images/clients/p4.png"),
      feedback:
        "I have been a member of this community for several years now, and it has been an invaluable resource for staying up-to-date with the latest trends and developments in the tech world. This community website is a must-visit for anyone interested in technology. It's a well-rounded platform that combines informative content with a supportive community, making it a great place to learn, share, and grow.",
    },
    {
      name: "Anoosh Salman",
      color: "indigo",
      rating: 5,
      image: require("../assets/images/clients/p5.png"),
      feedback:
        "AS- community has tremendously helped me polish my skills and made me a better writer. Anum has great talent of using words and she has the power to inspire others through her hardwork and dedication. Her work is her passion and ensuring outstanding quality is her goal.",
    },
    {
      name: "Abdullah Waseem",
      color: "indigo",
      rating: 5,
      image: require("../assets/images/clients/p6.png"),
      feedback:
        "I've worked with As tech community several times on different types of designing services. They communicate well, works until I am satisfied and have wide range of design abilities. Great work!",
    },
  ];

  const windowWidth = useWindowWidth();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [slidesToShow, setSlidesToShow] = useState(3);
  const containerRef = useRef(null);

  useEffect(() => {
    setSlidesToShow(windowWidth < 768 ? 1 : 3);
  }, [windowWidth]);

  const totalSlides = testimonials.length;

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % totalSlides);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + totalSlides) % totalSlides);
  };

  useEffect(() => {
    if (currentIndex >= totalSlides) {
      setCurrentIndex(0);
    } else if (currentIndex < 0) {
      setCurrentIndex(totalSlides - 1);
    }
  }, [currentIndex, totalSlides]);

  const variants = {
    enter: (direction) => ({
      x: direction > 0 ? 100 : -100,
      opacity: 0,
    }),
    center: {
      x: 0,
      opacity: 1,
    },
    exit: (direction) => ({
      x: direction < 0 ? 100 : -100,
      opacity: 0,
    }),
  };

  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 150">
        <defs>
          <linearGradient id="thirdGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="black" />
            <stop offset="100%" stopColor="#373AC8" />
          </linearGradient>
        </defs>
        <path
          fill="url(#thirdGradient)"
          fillOpacity="1"
          d="M0,64L34.3,58.7C68.6,53,137,43,206,42.7C274.3,43,343,53,411,80C480,107,549,149,617,144C685.7,139,754,85,823,85.3C891.4,85,960,139,1029,138.7C1097.1,139,1166,85,1234,64C1302.9,43,1371,53,1406,58.7L1440,64L1440,320L1405.7,320C1371.4,320,1303,320,1234,320C1165.7,320,1097,320,1029,320C960,320,891,320,823,320C754.3,320,686,320,617,320C548.6,320,480,320,411,320C342.9,320,274,320,206,320C137.1,320,69,320,34,320L0,320Z"
        />
      </svg>

      <div className="bg-gradient-to-r from-black to-logo py-12 md:px-24 text-white overflow-x-hidden">
        <div className="max-w-7xl mx-auto px-6">
          <div className="mb-6">
            <h2 className="text-3xl font-bold text-center">
              Join 300+ Community Members!
            </h2>
            <div className="border-t-4 border-orange-500 mt-2 w-10 mx-auto rounded-full"></div>
          </div>

          <div className="relative">
            <div
              className="overflow-x-hidden overflow-y-visible"
              ref={containerRef}
            >
              <motion.div
                className="flex h-full py-8 lg:mx-0 mx-[10px]"
                animate={{ x: `-${currentIndex * (100 / slidesToShow)}%` }}
                transition={{ type: "tween", ease: "easeInOut", duration: 0.5 }}
                drag="x"
                dragConstraints={{
                  left: -(
                    totalSlides *
                    (containerRef.current?.offsetWidth / slidesToShow || 1)
                  ),
                  right: 0,
                }}
                dragElastic={0.1}
                onDragEnd={(e, { offset, velocity }) => {
                  const slideWidth =
                    containerRef.current.offsetWidth / slidesToShow;
                  const slidesMoved = Math.round(offset.x / slideWidth);
                  let newIndex = currentIndex - slidesMoved;

                  if (newIndex < 0) newIndex = totalSlides - 1;
                  if (newIndex >= totalSlides) newIndex = 0;

                  setCurrentIndex(newIndex);
                }}
              >
                {[...testimonials, ...testimonials, ...testimonials].map(
                  (testimonial, index) => (
                    <motion.div
                      key={index}
                      className={`flex-shrink-0 ${
                        slidesToShow === 1 ? "w-full" : "w-1/3"
                      } px-3`}
                      variants={variants}
                      initial="enter"
                      animate="center"
                      exit="exit"
                      transition={{ duration: 0.5 }}
                      whileDrag={{ scale: 0.95, opacity: 0.9 }}
                    >
                      <div className="bg-white text-black p-6 rounded-lg shadow-lg relative transform transition-transform duration-300 lg:hover:scale-105">
                        <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-yellow-500 rounded-full p-3">
                          <FaQuoteLeft className="text-white" size={20} />
                        </div>
                        <p className="text-sm mb-4">
                          {testimonial.feedback.length > 230
                            ? `${testimonial.feedback.slice(0, 230)}...`
                            : testimonial.feedback}
                        </p>
                        <div className="flex items-center mt-4">
                          <img
                            src={testimonial.image}
                            alt={testimonial.name}
                            className="w-12 h-12 rounded-full mr-4"
                          />
                          <div>
                            <h4 className="font-bold">{testimonial.name}</h4>
                            <div className="text-orange-500 mt-2">
                              {"★".repeat(testimonial.rating)}{" "}
                              <span className="text-gray-400">
                                {"★".repeat(5 - testimonial.rating)}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </motion.div>
                  )
                )}
              </motion.div>
            </div>

            <button
              onClick={prevSlide}
              className="absolute -left-8 lg:-left-12 top-1/2 transform -translate-y-1/2 p-4 hover:text-yellow-500 text-white z-10"
            >
              <CiCircleChevLeft size={35} />
            </button>
            <button
              onClick={nextSlide}
              className="absolute -right-8 lg:-right-12 top-1/2 transform -translate-y-1/2 p-4 hover:text-yellow-500 text-white z-10"
            >
              <CiCircleChevRight size={35} />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Clients;
